import { createSelector } from 'reselect';

export interface CityStoresState {
  stores: any[];
  openCity: any;
  loading: boolean;
}

export const initialState: CityStoresState = {
  stores: [],
  loading: false,
  openCity: null,
};

const getStores = ({ cityStores }: any): CityStoresState => cityStores;

export const cityStoresSelectors = {
  getStores: createSelector(
    getStores,
    ({ stores }) => stores,
  ),

  getOpenCity: createSelector(
    getStores,
    ({ openCity }) => openCity,
  ),

  getLoading: createSelector(
    getStores,
    ({ loading }) => loading,
  ),
};



// WEBPACK FOOTER //
// ./src/scenes/CityStores/services/selectors.ts